<template>
    <div class="loading">
        <div>
            <img
                width="100"
                height="100"
                src="@/assets/icon/img_start_loading.gif"
                alt=""
            />
            <!-- <p style="margin-top: 10px">加载中...</p> -->
        </div>
    </div>
</template>

<script>
export default {
    name: "Loading",
};
</script>

<style scoped>
.loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #edf2fa; /* 半透明白色背景 */
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
